/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { monetizedSimilarListingsReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export { whitelist }
export const monetizedSimilarListings = filterActions<
  ReturnType<typeof monetizedSimilarListingsReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(monetizedSimilarListingsReducer, whitelist)
